<template>
  <div class="proposal__wrap">
    <div class="section shadow filter__wrap">
      <div class="flex" style="margin-bottom: 10px">
        <el-form
          ref="elFormDom"
          inline
          :model="table.params"
          @submit.native.prevent="handleSearch"
        >
          <el-form-item label="企业名称" prop="company_name">
            <el-input
              clearable
              size="mini"
              v-model="table.params.company_name"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="消耗类型" prop="trade_type">
            <el-select v-model="table.params.trade_type" clearable size="mini">
              <el-option label="查看简历" :value="7"></el-option>
              <el-option label="下载简历" :value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="getTable"
              >查询
            </el-button>
            <el-button icon="el-icon-refresh-right" @click="reset"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 表格 -->
    <div class="table__wrap">
      <VTable
        has-pagionation
        ref="tableDom"
        title=""
        addText="添加"
        :field="field"
        :loading="table.loading"
        :data="table.data"
        :page="table.params.page"
        :pageSize="table.params.count"
        :total="table.total"
        :tree-props="{ children: 'children', hasChildren: 'has_child' }"
        :hasPagionation="true"
        :default-expand-all="true"
        :showOverflowTooltip="true"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      >
        <template v-slot:coin="{ row }">
          <div>{{ row.coin }}个</div>
          <div>￥{{ row.amount }}</div>
        </template>
        <template v-slot:trade_type="{ row }">
          <div>{{ { 4: "下载简历", 7: "查看简历" }[row.trade_type] }}</div>
          <div style="font-size: 12px;color: #838a9d;">{{ row.education_str }} {{ row.college_type_str }}</div>
        </template>
        <template v-slot:user_name="{ row }">
          <div>{{ row.user_name }}</div>
          <div v-if="row.has_user_auth == 0">{{ row.school_str }}</div>
          <div v-if="row.has_user_auth == 1">
            (认证学校:{{ row.school_str }})
          </div>
        </template>
        <template v-slot:agent_coin="{ row }">
          <el-popover trigger="click" placement="top-start">
            <div style="text-align:center">代理收益</div>
            <div>
              学校代理: <span>{{row.agent_school_name}} {{row.agent_school_account}} ￥{{row.agent_school_coin}}</span>
            </div>
            <div>
              拉新代理: <span>{{row.agent_name}} {{row.agent_account}} ￥{{row.agent_coin}}</span>
            </div>
            <el-button slot="reference" type="text">￥{{ row.total_agent_coin }}</el-button>
          </el-popover>
        </template>
        <template v-slot:auth_user_coin="{ row }">
          <span>￥{{ row.auth_user_coin }}</span>
        </template>
        <template v-slot:surplus_coin="{ row }">
          <span>￥{{ row.surplus_coin }}</span>
        </template>
      </VTable>
    </div>
  </div>
</template>

<script>
import VTable from "@/components/VTable";
import { mixinTable } from "@/mixins/table.js";
export default {
  mixins: [mixinTable],
  components: {
    VTable,
  },
  data() {
    return {
      field: [
        { name: "company_name", label: "企业名称", hidden: false },
        { name: "coin", label: "消耗人才币", hidden: false, width: 100 },
        { name: "trade_type", label: "消耗类型", hidden: false },
        { name: "user_name", label: "明细", hidden: false },
        { name: "agent_coin", label: "代理收益", hidden: false },
        { name: "auth_user_coin", label: "认证用户收益", hidden: false },
        { name: "surplus_coin", label: "平台收益", hidden: false },
        { name: "pay_time", label: "消耗时间", hidden: false },
      ],
      table: {
        loading: false,
        params: {
          company_name: "",
          trade_type: "",
          page: 1,
          count: 10,
        },
        data: [],
        total: 0,
        wait_total: 0,
        ing_total: 0,
        finish_total: 0,
      },
    };
  },
  created() {
    this.getTable();
  },
  methods: {
    reset() {
      this.$refs.elFormDom.resetFields();
      this.table.params.page = 1;
      this.getTable();
    },
    getTable() {
      this.$http
        .get("/admin/order/divideList", { params: this.table.params })
        .then((res) => {
          if (res.code === 1) {
            this.table.data = res.data.list;
            this.table.total = res.data.total;
            this.table.wait_total = res.data.wait_total;
            this.table.ing_total = res.data.ing_total;
            this.table.finish_total = res.data.finish_total;
            this.$nextTick(() => {
              this.$refs.tableDom.$refs.multipleTable.doLayout();
            });
          }
        });
    },
  },
};
</script>

<style scoped lang="scss">
.flex {
  display: flex;
}
.proposal__wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;

  .filter__wrap {
    padding: 10px;
    margin-bottom: 20px;
    // display: flex;
    // justify-content: space-between;
  }

  .table__wrap {
    flex: 1;
    padding: 0;
    box-sizing: border-box;
  }
}
.title-box {
  display: flex;
  align-items: center;
  .title-box-right {
    margin-left: 8px;
  }
}
.title-box-right-1 {
  display: flex;
  align-items: center;
  .sex {
    margin-left: 8px;
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;
  }
}
.isman {
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #25a5e2;
}
.iswomen {
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #ff8ba9;
}
.bage-box {
  height: 8px;
  width: 8px;
  padding: 0;
  position: absolute;
  right: 0;
  top: 0;
  background: #f56c6c;
  border-radius: 50%;
}
</style>